import { t } from "../../utils/i18n";
import React from "react";

const AddFundsModal = ({ closeModal }) => (
  <div
    className="modal fade"
    id="addFundsModal"
    tabIndex="-1"
    aria-labelledby="addFundsModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title" id="addFundsModalLabel"><i class="fa-solid fa-triangle-exclamation"></i>
          &nbsp; {t("transfers_send.common.fund_your_account_title")}</h4>
        </div>
        <div className="modal-body" data-controller="clipboard">
          <div className="row mx-auto modal-addfundsbody">
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{ __html: t("transfers_send.pay_me.fund_modal_html") }}
            />
          </div>
          <div className="paymepage-buttons-section">
            
            <div>
              <button
                type="button"
                className="paymepage-cancelbtn"
                data-dismiss="modal">
                {t("transfers_send.common.close")}
              </button>
            </div>
            <div>
                <a
                  href="/add_funds"
                  target="_blank"
                  role="button"
                  className="paymepage-paidbtn">{t("transfers_send.common.add_funds")}
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AddFundsModal;
